module.exports = __webpack_public_path__ + "img/icon-delete.8e2458d0.svg";